'use client';

import Image from "next/image";
import { partnerLogo } from "@/utils/partnerLogo"; 

// Divide logos same as Code 2
const ROW1_LOGOS = partnerLogo.slice(0, 60);
const ROW2_LOGOS = partnerLogo.slice(60, 110);
const ROW3_LOGOS = partnerLogo.slice(110);

export function PartnersMarqueeSection() {
  return (
    <section className="relative py-14 md:py-18 bg-white">
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">

        {/* Heading */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-slate-900 mb-3">
            300+ Trusted Partners
          </h2>
          <p className="text-sm md:text-base text-slate-500 max-w-2xl mx-auto">
            Building success together with leading brands and innovators across
            multiple industries.
          </p>
        </div>

        <div className="space-y-2 md:space-y-2">

          {/* Row 1 – LTR */}
          <MarqueeRow
            logos={ROW1_LOGOS}
            direction="ltr"
            speed="238s"
          />

          {/* Row 2 – RTL */}
          <MarqueeRow
            logos={ROW2_LOGOS}
            direction="rtl"
            speed="345s"
          />

          {/* Row 3 – LTR */}
          <MarqueeRow
            logos={ROW3_LOGOS}
            direction="ltr"
            speed="240s"
          />
        </div>
      </div>

      {/* Marquee animations */}
      <style jsx global>{`
        @keyframes marquee-ltr {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
        @keyframes marquee-rtl {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .marquee-row:hover .marquee-track {
          animation-play-state: paused;
        }
        .marquee-track-ltr {
          animation-name: marquee-ltr;
        }
        .marquee-track-rtl {
          animation-name: marquee-rtl;
        }
        .marquee-track {
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }
      `}</style>
    </section>
  );
}

/* ----------------- Sub-components ----------------- */

function MarqueeRow({ logos, direction = "ltr", speed = "40s" }) {
  const trackClass =
    direction === "rtl"
      ? "marquee-track marquee-track-rtl"
      : "marquee-track marquee-track-ltr";

  // Duplicate items for looping marquee
  const items = [...logos, ...logos];

  return (
    <div className="relative marquee-row overflow-hidden">

      {/* Faders */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 bg-gradient-to-r from-white via-white/90 to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 bg-gradient-to-l from-white via-white/90 to-transparent z-10" />

      {/* Track */}
      <div
        className={`${trackClass} flex w-max items-center gap-2 md:gap-2`}
        style={{ animationDuration: speed }}
      >
        {items.map((logo, index) => (
          <LogoCard key={`${logo.id || index}-${index}`} logo={logo} />
        ))}
      </div>
    </div>
  );
}

function LogoCard({ logo }) {
  return (
    <div className="flex h-16 md:h-20 lg:h-20 min-w-[160px] md:min-w-[190px] lg:min-w-[210px] items-center justify-center   bg-white border border-slate-200 shadow-sm ">
      <Image
        src={logo.img}       
        alt={logo.altText}   
        width={200}
        height={150}
        className="w-auto object-cover h-full"
      />
    </div>
  );
}
